import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import type { CommunityEssentialFolderModel, CommunityEssentialModel } from '@/models'

export interface FolderContentResponse {
  essentials: CommunityEssentialModel[]
  folders: CommunityEssentialFolderModel[]
}

export interface GetFolderContentRequest {
  buildingId?: number
  folderId: number
}

export const GET_FOLDER_CONTENT_BASE_QUERY_KEY = 'useGetFolderContent'

export const getFolderContentQueryKey = (data: GetFolderContentRequest) => [
  GET_FOLDER_CONTENT_BASE_QUERY_KEY,
  data,
]

export const getFolderContent = async (data: GetFolderContentRequest, signal?: AbortSignal) => {
  const response = await authAPI.get<FolderContentResponse>(
    `/building-essential/${data.buildingId}/folder/${data.folderId}`,
    { signal },
  )
  return response.data
}

export const useGetFolderContent = (data: GetFolderContentRequest) => {
  return useQuery({
    enabled: !!data.buildingId && data.folderId >= 0,
    placeholderData: {
      essentials: [],
      folders: [],
    },
    queryFn: ({ signal }) => getFolderContent(data, signal),
    queryKey: getFolderContentQueryKey(data),
    select: (response) => ({
      essentials: [...response.essentials].sort((a, b) => a.position - b.position),
      folders: [...response.folders].sort((a, b) => a.position - b.position),
    }),
  })
}
